import { useState, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useAxios } from '../Components/axiosContext.js';
import { Appointment } from '../types/appointments.js';
import { AxiosInstance } from 'axios';

export const useCallsByType = () => {
  const [calls, setCalls] = useState<{
    INTAKE1?: Appointment | null;
    INTAKE2?: Appointment | null;
    INTAKE3?: Appointment | null;
  }>({
    INTAKE1: null,
    INTAKE2: null,
    INTAKE3: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useUser();
  const axios = useAxios() as AxiosInstance;

  const fetchCallsByType = async () => {
    if (!user?.id || !axios) return;

    setLoading(true);
    setError(null);

    try {
      // Fetch all calls for the user
      // Alternative: Use API filtering with: axios.get('/calls', { params: { type: 'INTAKE1,INTAKE2,INTAKE3' } })
      const response = await axios.get('/calls', {
        params: {
          type: 'INTAKE1,INTAKE2,INTAKE3',
        },
      });

      if (response.data.success) {
        const callsData = response.data.data as Appointment[];

        // Filter and organize calls by type
        const callsByType = {
          INTAKE1: callsData.find((call) => call.type === 'INTAKE1') || null,
          INTAKE2: callsData.find((call) => call.type === 'INTAKE2') || null,
          INTAKE3: callsData.find((call) => call.type === 'INTAKE3') || null,
        };

        setCalls(callsByType);
      } else {
        setError('Failed to fetch calls');
      }
    } catch (err: any) {
      console.error('Error fetching calls by type:', err);
      setError(err.response?.data?.message || 'Failed to fetch calls');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCallsByType();
  }, [user?.id, axios]);

  return {
    calls,
    loading,
    error,
    refetch: fetchCallsByType,
  };
}; 